import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ApplicationEnvironmentMessageComponent} from "./application-environment-message.component";
import {AppConfig} from "@app/services/app.config";

@NgModule({
  declarations: [ApplicationEnvironmentMessageComponent],
  imports: [CommonModule],
  providers: [AppConfig],
  exports: [ApplicationEnvironmentMessageComponent],
})
export class ApplicationEnvironmentMessageModule {}
